import React from 'react';
import { ArticleBlock, ArticleBlockProps } from '../../components/ArticleBlock/ArticleBlock';
import { BreadcrumbProps, Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { useArticleProps } from '../../hooks/content/useArticleProps';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';
import { ArticleRichTextLayoutBlockContextProvider } from '../../hooks/useArticleRichTextLayoutBlockProps';
import { ArticleHeader, ArticleHeaderProps } from '../../components/ArticleHeader/ArticleHeader';
import { RelatedEntries, RelatedEntriesProps } from '../../components/RelatedEntries/RelatedEntries';
import { Disclaimer } from '@jbhi-fi/components/src/Disclaimer';
import { styles } from './Article.css';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

export type ArticleProps = {
  articleHeader?: ArticleHeaderProps;
  breadcrumbs: BreadcrumbProps;
  articleBlock: ArticleBlockProps;
  relatedEntries?: RelatedEntriesProps;
};

export const Article: React.FC = () => {
  const { data: article, isLoading, error } = useArticleProps();
  const { breadcrumbs, articleBlock, relatedEntries, articleHeader } = article;
  const isVideoArticle = Boolean(articleHeader?.videoSrc);

  // TODO: Create a nice error handler
  if (error) return <>{error}</>;

  return (
    <>
      <Breadcrumbs className={styles.breadcrumbs} {...breadcrumbs} />
      <ContentBlock
        style={{ backgroundColor: palette.primary.light }}
        paddingTop={0}
        paddingLeft={0}
        paddingRight={0}
        paddingBottom={{ mobile: 10, tablet: 20 }}
      >
        <div className={styles.pageContainer}>
          <ArticleHeader {...articleHeader} />
          <div className={styles.articleBlock({ isVideoArticle })}>
            <ContentBlock
              paddingTop={0}
              paddingLeft={0}
              paddingRight={0}
              maxWidth="medium"
              style={{ backgroundColor: palette.primary.light }}
            >
              <ArticleRichTextLayoutBlockContextProvider paddingTop={5}>
                <ArticleBlock {...articleBlock} isLoading={isLoading} />
              </ArticleRichTextLayoutBlockContextProvider>
              <ContentBlock paddingTop={15} paddingBottom={0} paddingX={{ xs: 4, md: 8 }}>
                <Disclaimer disclaimers={window.Jbhifi.disclaimers} />
              </ContentBlock>
            </ContentBlock>
          </div>
        </div>
      </ContentBlock>
      {relatedEntries.filter ? (
        <ContentBlock
          style={{ backgroundColor: palette.secondary.dark }}
          paddingBottom={{ mobile: 10, tablet: 16 }}
          paddingLeft={0}
          paddingRight={0}
          paddingTop={15}
        >
          <ContentBlock paddingTop={0}>
            <RelatedEntries {...relatedEntries} />
          </ContentBlock>
        </ContentBlock>
      ) : null}
    </>
  );
};
